// removed by extract-text-webpack-plugin
module.exports = {"stateName":"_3czsy","ongoingStamp":"LviYT","primList":"DtbQE","primListFirst":"_1P2ve","primListList":"_1KAp5","primListDone":"_1Y8W_","primListItem":"_3qOEC","primListItemDate":"_2VMsM _3qOEC","primListItemMap":"_38dpV _3qOEC","primListItemState":"_9DRuh _3qOEC","primListItemWinner":"_1s6kd _3qOEC","winnerImg":"_2-r5p","winnerName":"_341qD","winnerFirstName":"_2y7wS","date":"_3id2e","day":"_1kXFf","text":"_2uP_u","rep":"_31RFj","dem":"_2E305","readMore":"_1lw5o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Primary.scss
 ** module id = 24
 ** module chunks = 0
 **/